import { config } from './config';
import { currentSession, signOut } from './auth';

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
    public details?: Record<string, unknown>,
  ) {
    super(message);
  }
}

// One client for the one API. Fails soft on transient trouble — only an
// explicit 401 ends the session, never a network blip.
export async function api<T>(
  method: string,
  path: string,
  body?: unknown,
): Promise<T> {
  const session = currentSession();
  const res = await fetch(`${config().apiBase}${path}`, {
    method,
    headers: {
      ...(body !== undefined ? { 'content-type': 'application/json' } : {}),
      ...(session ? { authorization: `Bearer ${session.idToken}` } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  if (res.status === 401) {
    signOut();
    window.location.hash = '#/signin';
    throw new ApiError(401, 'unauthenticated', 'Signed out.');
  }
  const parsed = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new ApiError(
      res.status,
      parsed.code ?? 'unknown',
      parsed.message ?? 'Something went wrong.',
      parsed.details,
    );
  }
  return parsed as T;
}
